import DownloadErrorFileBtn from './DownloadErrorFileBtn'

export default DownloadErrorFileBtn
